<template>
  <div class="login" v-loading="styleChoose">
    <!-- 主体内容 -->
    <el-container 
      :class="[
        'login-row', 
        'bgStyle-' + pcConfig.themePc, 
        getBgClass
      ]"
    >
      <!-- 顶部 -->
      <login-header
        :loginPng="pcConfig.logo !== '' ? $imgurl + pcConfig.logo : 'https://bigdata.topeti.com/PCRepository/mainPlatform/mainsLogo.png'"
        :initial="typeStyle"
      />

      <!-- 背景 -->
      <div class="containerBg">
        <el-image
          class="image"
          style="pointer-events: none;cursor: default;"
          :src="
            pcConfig.themePc != ''
              ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/mainBg-' + pcConfig.themePc + '.png'
              : 'https://bigdata.topeti.com/PCRepository/'+$imgfile+'/new-mainBg.png'
          "
          fit="contain"
        ></el-image>
      </div>

      <!-- 右边操作栏 -->
      <div class="toolArea" :class="{ scaled: isScaled }">
        <div class="toolContent">
          <login-user
            v-if="tapValue == 0"
            ref="loginUser"
            :theme="pcConfig.themePc"
            :isAddUser="isAddUser"
            :loginFail="$imgurl + pcConfig.fail"
            @forgetPassword="forgetPassword"
            @select-user="selectUser"
          ></login-user>
          <login-phone
            v-else-if="tapValue == 1"
            ref="loginPhone"
            :theme="pcConfig.themePc"
            :isAddUser="isAddUser"
            @forgetPassword="forgetPassword"
            @select-user="selectUser"
          ></login-phone>
          <loginCode 
          v-else-if="tapValue == 2"
          :isAddUser="isAddUser"
          @goBack="goBack"></loginCode>
          <!-- 忘记密码 -->
          <div class="toolContentBottom">
            <div :class="'goPhone theme-' + pcConfig.themePc" @click="changeTap" v-if="tapValue == 0 && showMobilePsw">手机动态码登录</div>
            <div :class="'goPhone theme-' + pcConfig.themePc" @click="changeTap" v-else-if="tapValue == 1">账号登录</div>
            <div class="forgetArea" v-if="(tapValue == 0 || tapValue == 1) && showMobilePsw" @click="forgetPassword()">找回密码</div>
          </div>
          <div class="login-tips">
            <p>登录代表同意 <span @click="protocolVisible = true">《隐私政策》</span></p>
            <p style="color: #F02727;padding-top: 10px;">本平台为互联网非涉密平台，严禁处理、传输国家秘密</p>
          </div>
        </div>
        <!-- 其他区域 -->
        <div class="otherArea" v-if="tapValue == 0 || tapValue == 1">
          <el-divider>其他方式登录</el-divider>
          <div class="otherArea-item">
            <div class="wxlogin" v-if="isShowWx.indexOf(host) !== -1">
              <el-image  @click="goWeChat" :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/wechat.png'" ></el-image>
            </div>
            <!-- 市局专属 -->
            <div class="ixmlogin" v-if="isShowIxm.indexOf(host) !== -1">
              <el-image  @click="goIXM" class="ixm" :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/iAM.png'"></el-image>
            </div>
            <!-- 市属学校专属 -->
            <div class="ixmlogin" v-if="isShowIxmXX.indexOf(host) !== -1">
              <el-image  @click="goIXMXX" class="ixm" :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/iAM.png'"></el-image>
            </div>
            <!-- 厦大专属 -->
            <div class="xmulogin" v-if="isShowXMU.indexOf(host) !== -1">
              <el-image  @click="goXMU" class="xmu" :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/btn-xiada.png'"></el-image>
            </div>
          </div>
        </div>
      </div>
    </el-container>
    <!-- 底部 -->
    <div class="footer">
      <div class="footer-shadow">
        <span>{{pcConfig.words}}</span>
        <el-popover placement="top" trigger="hover" width="143" popper-class="erweima">
          <div class="erweima-hover">
            <img
              :src="pcConfig.qrcode !== '' ? $imgurl + pcConfig.qrcode : 'https://bigdata.topeti.com/PCRepository/mainPlatform/new-QrCode.png'"
            />
          </div>
          <template #reference>
            <i class="iconfont icon-erweima-"></i>
          </template>
        </el-popover>
      </div>
    </div>
    <!-- 忘记/重置密码 -->
    <up-iphone ref="upIphone"></up-iphone>
    <!-- 登录失败弹窗 -->
    <el-dialog
      class="dialog-tips"
      v-model="dialogTips"
      width="520px">
      <img :src="$imgurl + pcConfig.fail" />
    </el-dialog>
    <protocol v-model:isView="protocolVisible" />
    <ChangeUser v-model:isView="isViewChangeUser" type="add" :list="userList" />
  </div>
</template>

<script>

import { thirdUrlShow, getloginweb } from "@/port/pages/login";
import ChangeUser from '@/components/common/changeUser.vue';
import loginHeader from '@/pages/components/loginHeader.vue'
import loginPhone from '@/pages/components/loginPhone.vue'
import loginUser from '@/pages/components/loginUser.vue'
import loginCode from '@/pages/components/loginCode.vue'
import upIphone from '@/components/common/upIphone.vue'
import protocol from '@/components/common/protocol.vue'
export default {
  name: 'loginPage',
  data () {
    return {
      //- 界面样式参数
      typeStyle: 1,
      //- 界面切换样式状态参数
      styleChoose: false,
      //- tap数据集
      tapArray: [{
        name: '客户端',
        value: 1,
      }, {
        name: '手机动态码登录',
        value: 2,
      }],
      //- tap选中值
      tapValue: 0,
      //- 第三方登录地址
      thirdUrl: "",
      host: '',
      // 市局显示i厦门登录的入口
      isShowIxm: [
        // 本地环境
        // 'localhost:8081',
        // 'localhost:8080'
        ],
      // 市属学校显示i厦门登录的入口
      isShowIxmXX: [
        'eduxm.topeti.com',
        'xm.sszx.cn',
        // 本地环境
        // 'localhost:8081',
        // 'localhost:8080'
        ],
      // 显示微信登录的入口
      isShowWx: [
        // 学校
        'xmedu.topeti.com',
        'eduxm.topeti.com',
        'xmeduzt.topeti.com',
        'xm.sszx.cn',
        'itayz.xmedu.cn',
        // 翔安
        'zhxy.xmxdzx.com',
        // 阿里
        'user.topeti.com',
        'mp.topeti.com',
        'jjyz.topeti.com',
        '10.95.249.6',
        // 集美教育局
        'guanli.xmjmedu.com',
        'guanli.xmjmedu.com:80',
        // 测试环境
        'edu.topeti.com',
        'eduzt.topeti.com',
        'zhihui.xmycxx.com', // 英才
        // 本地环境
        'localhost:8081',
        'localhost:8080',
        'localhost:8082'
      ],
      // 显示厦大登录入口
      isShowXMU: [
        'smart-aerospace.xmu.edu.cn',
        'smart-aerospace2.xmu.edu.cn',
        'idata.xmu.edu.cn',
        'smartsbd.xmu.edu.cn',
        'smartsbd2.xmu.edu.cn',
        'chemplatform.xmu.edu.cn'
      ],
      // 隐藏手机动态码登录、找回密码（国贸需求）
      showMobilePsw: true,
      pcConfig: {
        themePc: 'blue',
        logo: '',
        fail: '',
        words: '',
        qrcode: ''
      },
      // 自定义背景图
      showBg: '',
      dialogTips: false,
      qrCcdeStatus: false, // 判断是否微信扫码失败跳转返回
      domainHref: '', //当前访问域名
      isAddUser: false,
      isViewChangeUser: false,
      protocolVisible: false,
      userList: [],
      isScaled: false //登录框是否缩放显示（厦大化院需求）
    };
  },
  components: {
    loginHeader,
    loginUser,
    loginPhone,
    loginCode,
    upIphone,
    protocol,
    ChangeUser
  },
  methods: {
    // 选择用户登录
    selectUser(val) {
      this.userList = val
      this.isViewChangeUser = true
    },
    //- 选择tap
    changeTap () {
      if(this.tapValue == 1 ){
        this.tapValue = 0
        return
      }
      this.tapValue = 1
    },
    //  i厦门登录
    goIXM(){
      window.location.href =
        "https://www.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://www.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT";
    },
    //  市属i厦门登录
    goIXMXX(){
      window.location.href =
        "https://www.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://www.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=XMDLZXSER";
    },
    // 厦大登录
    goXMU(){
      window.location.href =
        "http://ids.xmu.edu.cn/authserver/login?service=" + this.domainHref + "/ixiadalogin";
    },
    // 微信登录
    goWeChat(){
      this.tapValue = 2
    }, 
    // 微信返回上一层
    goBack(){
      this.tapValue = 0
    },
    //- 忘记密码/重置密码
    forgetPassword (val) {
      if (!val) {
        this.onclearStorage();
        val = {
          title: "忘记密码",
          bottom: "重置密码",
          origin: "login"
        };
      }
      console.log("forgetPassword", val)
      this.$refs.upIphone.showDialog(val);
    },
    //- 清除缓存数据
    onclearStorage () {
      const historymsg = localStorage.getItem('historymsg')
      const list = localStorage.getItem('userList')
			localStorage.clear();
      sessionStorage.clear();
      if (list) localStorage.setItem('userList', list)
			if(historymsg)localStorage.setItem('historymsg',historymsg)
    },
    //- 获取登录页配置
    getLoginWeb () {
      let that = this;
      that.styleChoose = true
      console.log("getLoginWebgetLoginWeb");
      getloginweb().then(res => {
        setTimeout(function(){
          if (res.code === 0) {
            if(res.data.pcconfig){
              let loginData = JSON.parse(res.data.pcconfig);
              that.pcConfig = loginData;
            }
            var qrCcdeStatus = localStorage.getItem('qrCcdeStatus')
            if(qrCcdeStatus && that.pcConfig.fail !== ''){
              that.dialogTips = true;
              localStorage.removeItem('qrCcdeStatus')
            }
          } else {
            that.$message.error(res.msg);
          }
        },1000)
        this.styleChoose = false
      })
      .catch(error => {
        this.styleChoose = false
        console.log(error);
      });
      
    },
    // 弹出登录失败弹窗
    failDialogShow(){
      this.dialogTips = true;
    },
    checkDevicePixelRatio() {
      this.isScaled = window.devicePixelRatio >= 1.25
    },
    handleZoomChange() {
      setTimeout(this.checkDevicePixelRatio, 100)
    }
  },
  computed: {
    rxConnect () {
      return this.$store.state.rxConnect;
    },
    // 自定义背景图片
    getBgClass() {
      if (this.showBg === 'yc') {
        return 'login-yc';
      } else if (this.showBg === 'hy') {
        return 'login-hy';
      }
      return '';
    }
  },
  mounted() {
    this.checkDevicePixelRatio()
    window.addEventListener('resize', this.handleZoomChange)
    this.isAddUser = this.$route.path === '/addLogin'
    // 隐藏手机动态码登录、找回密码（国贸需求）
    this.showMobilePsw = this.$apiurl === 'http://10.66.99.244' || this.$apiurl === 'http://10.66.99.244:8088' || this.$apiurl === 'http://app.itgedu.com.cn' ? false :true
    if(this.$apiurl === 'https://zhihui.xmycxx.com'){
      this.showBg = 'yc'
    }
    else if(this.$apiurl === 'https://chemplatform.xmu.edu.cn'){
      this.showBg = 'hy'
    }
    // 获取header里的服务器时间
    // 生成随机数
    let randomNum = "";
    for (let i = 0; i < 6; i++) {
      randomNum += Math.floor(Math.random() * 10);
    }
    // 获取header里的服务器时间
    let nowDate = new Date(); //本地时间
    let that = this;
    fetch(window.location+"?randomNum="+randomNum).then(function(resp) {    
      resp.headers.forEach(function(val, key) {
        // console.log(key + ' -> ' + val);
        if(key == 'date'){
          localStorage.removeItem('differTime');          
          let serverDate = new Date(val); //服务器时间
          let differTime = nowDate.getTime() - serverDate.getTime(); //服务器和本地毫秒时间差
          // console.log("serverDate",serverDate,serverDate.getTime());
          // console.log("nowDate",nowDate,nowDate.getTime());
          // console.log("differTime",differTime);
          localStorage.setItem('differTime', differTime);   
          // 获取登录页配置
          that.getLoginWeb();       
        }
      });
    });
    //- 之前的一些页面场景判断(有用)
    var accesstoken = JSON.parse(localStorage.getItem("user"))
    // 获取当前域名
    this.host = window.location.host
    //- 厦门教育局有个I厦门登陆
    if ((window.location.host == "xmjyj.topeti.com" || window.location.host == "yqfk.xmedu.cn") && (!accesstoken || !accesstoken.accesstoken)) {
      window.location.href =
        "https://www.ixiamen.org.cn/ids/custom/xiamen/login_xm.jsp?loginType=Citizen&returnUrl=https://www.ixiamen.org.cn/ids/custom/xiamen/autoSubmitForProxyLogin.jsp?coAppName=SSJKSBXT";
    }
    if (accesstoken && accesstoken.accesstoken && !this.isAddUser) {
      this.$router.push({ path: "/index" });
    }
    if (this.$route.query.thirdMsg) {
      //如果第三方登陆
      alert(this.$route.query.thirdMsg);
    }
    this.thirdUrl = thirdUrlShow();
    this.domainHref = window.location.protocol+"//"+window.location.host
    console.log("this.domainHref==",this.domainHref);
    //- 判断是不是平台切换进入
    // this.judgePlatform();    
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleZoomChange)
  },
}
</script>

<style scoped lang="scss">
@import './components/common.scss';
.login-row {
  width: 100%;
  height: 100vh;
  position: relative;
  &.bgStyle-blue {
    background: linear-gradient(to bottom right, #333dc5, #409bf7);
  }
  &.bgStyle-red {
    background: linear-gradient(122.69deg, #E84735 0%, #FCB177 100%);
  }
  &.bgStyle-green {
    background: linear-gradient(135deg, #0EA15F 0%, #42E39A 100%);
  }
  .containerBg {
    position: fixed;
    top: 24.56%;
    left: 11%;
    // -webkit-transform: translateX(-50%);
    // transform: translateX(-50%);
    width: 44%;
  }
  .toolArea {
    position: fixed;
    top: 20%;
    right: 0%;
    width: 299px;
    padding: 20px 30px;
    min-height: 279px;
    border-radius: 20px;
    background-color: white;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    .toolContentBottom {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      .forgetArea {
          cursor: pointer;
          color: #999999;
        }

      .goPhone{
          cursor: pointer;
          color: #4e86ff;
      }
    }
    .login-tips {
      padding-top: 10px;
      text-align: center;
      p {
        line-height: 20px;
        color: #999;
        span {
          color: #4E86FE;
          cursor: pointer;
          &:hover {
              text-decoration: underline;
          }
        }
      }
    }
    
    .otherArea {
      width: 100%;
      margin-top: 27px;
      text-align: center;
      ::v-deep .el-divider__text {
        color: #999999;
      }

      .otherArea-item{
        margin: 0 auto;
        display: flex;
        justify-content: center;
        .el-image{
          cursor: pointer;
        }
        .wxlogin{
          width: 35px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .ixmlogin{
            margin-left: 30px;
        }
        .xmulogin{
          width: 180px;
        }
      }
    }
  }
  // 登录框根据浏览器放大后缩放显示（厦大化院需求）
  // .toolArea.scaled {
  //   transform: translateX(-50%) scale(0.6);
  //   transform-origin: center top;
  // }
}
.login-yc {
  background: #05338D url('https://bigdata.topeti.com/PCRepository/image/bg-yc.png') no-repeat 0 100% !important;
}
.login-hy {
  background: #095EAA url('https://bigdata.topeti.com/PCRepository/image/bg-huayuan.jpg') no-repeat 0 100% !important;
}
.login-yc .containerBg,
.login-hy .containerBg {
  display: none;
}
.footer {
  width: 96%;
  padding: 0 2%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: 48px;
  color: white;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  .footer-shadow {
    // display: inline-block;
    line-height: 48px;
    // display: flex;
    // justify-content: flex-end;
    span:nth-child(1){
      display: inline-block;
      margin-right: 30px;
    }

    .iconfont{
      position: relative;
      top: 2px;
      font-size: 21px;
    }

    
  }
  
  
}
.erweima-hover{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #999999;

    img {
      width: 100px;
      height: 100px;
    }

    span{
      // display: inline-block;
      // width: 21px;
      line-height: 16px;
      // margin-top: 4px;
    }
  }
.theme-blue {
  color: #4e86ff !important;
}
.theme-red {
  color: #E62E19 !important;
}
.theme-green {
  color: #0EA15F !important;
}
.dialog-tips {
  text-align: center;
  ::v-deep .el-dialog__body {
    padding: 10px;
    img {
      max-width: 500px;
      max-height: 500px;
      margin: 0 auto;
    }
  }
  
}
</style>
<style>
  .erweima{
    height: 143px;
    padding-top: 18px !important;
    border-radius: 18px;
    color: #333dc5;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
</style>